import React from "react";

import Typography from "@material-ui/core/Typography";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

import { i18n } from "../../../translate/i18n.js";

// feat_347 — extraído VERBATIM de Settings/index.js:90-268 (era un sub-componente
// definido inline en el mismo archivo). Cero cambios de contenido: los 29 strings
// hardcodeados en español y el baseUrl hardcodeado quedan tal cual — su traducción
// es Fase 2.
const DevSection = ({ apiToken, classes }) => {
	const [copied, setCopied] = React.useState("");
	const baseUrl = "https://apiwaia.zzia.info";
	const tok = apiToken || "TU_TOKEN_AQUI";

	const copy = (text, key) => {
		navigator.clipboard.writeText(text).catch(() => {});
		setCopied(key);
		setTimeout(() => setCopied(""), 2000);
	};

	const ENDPOINTS = [
		{
			method: "POST",
			path: "/api/messages/send",
			description: "Enviar mensaje de texto a un número de WhatsApp",
			body: [
				{ field: "contactNumber", type: "string", required: true, desc: "Número en formato internacional (ej: 5491112345678)" },
				{ field: "message", type: "string", required: true, desc: "Texto del mensaje" },
				{ field: "ticketId", type: "number", required: false, desc: "Asociar a un ticket existente (opcional)" },
			],
			curl: `curl -X POST ${baseUrl}/api/messages/send \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"contactNumber":"5491112345678","message":"Hola desde la API"}'`,
			response: `{ "id": "MSG_ID", "body": "Hola desde la API", "fromMe": true }`
		},
		{
			method: "GET",
			path: "/api/contacts/phone/:number",
			description: "Buscar contacto por número de teléfono",
			body: [],
			curl: `curl -X GET "${baseUrl}/api/contacts/phone/5491112345678" \\
  -H "x-api-token: ${tok}"`,
			response: `{ "id": 1, "name": "Juan", "number": "5491112345678", "aiStatus": "attending", "humanIntervention": false }`
		},
		{
			method: "PUT",
			path: "/api/contacts/phone/:number/intervention",
			description: "Activar o desactivar intervención humana (pausa la IA)",
			body: [
				{ field: "humanIntervention", type: "boolean", required: true, desc: "true = pausa IA, false = retoma IA" },
			],
			curl: `curl -X PUT ${baseUrl}/api/contacts/phone/5491112345678/intervention \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"humanIntervention":true}'`,
			response: `{ "id": 1, "humanIntervention": true }`
		},
		{
			method: "PUT",
			path: "/api/contacts/phone/:number/ai-status",
			description: "Actualizar estado IA del contacto (attending / done / null)",
			body: [
				{ field: "aiStatus", type: "string | null", required: true, desc: '"attending", "done" o null para reiniciar' },
			],
			curl: `curl -X PUT ${baseUrl}/api/contacts/phone/5491112345678/ai-status \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"aiStatus":"done"}'`,
			response: `{ "id": 1, "aiStatus": "done" }`
		},
		{
			method: "POST",
			path: "/api/contacts/phone/:number/assign",
			description: "Asignar el ticket activo del contacto a un departamento",
			body: [
				{ field: "queueName", type: "string", required: false, desc: "Nombre del departamento (ej: Ventas)" },
				{ field: "queueId", type: "number", required: false, desc: "ID del departamento (alternativa a queueName)" },
				{ field: "userId", type: "number", required: false, desc: "ID del asesor a asignar (opcional)" },
			],
			curl: `curl -X POST ${baseUrl}/api/contacts/phone/5491112345678/assign \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"queueName":"Ventas"}'`,
			response: `{ "id": 1, "queueId": 2 }`
		},
		{
			method: "PUT",
			path: "/api/contacts/phone/:number/type",
			description: "Asignar tipo de cliente al contacto",
			body: [
				{ field: "typeName", type: "string", required: false, desc: "Nombre del tipo (ej: Premium)" },
				{ field: "contactTypeId", type: "number", required: false, desc: "ID del tipo (alternativa a typeName)" },
			],
			curl: `curl -X PUT ${baseUrl}/api/contacts/phone/5491112345678/type \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"typeName":"Premium"}'`,
			response: `{ "id": 1, "contactTypeId": 3 }`
		},
		{
			method: "POST",
			path: "/api/contacts/phone/:number/internal-note",
			description: "Agregar nota interna al ticket activo del contacto",
			body: [
				{ field: "note", type: "string", required: true, desc: "Texto de la nota interna" },
			],
			curl: `curl -X POST ${baseUrl}/api/contacts/phone/5491112345678/internal-note \\
  -H "Content-Type: application/json" \\
  -H "x-api-token: ${tok}" \\
  -d '{"note":"Cliente VIP, tratar con prioridad"}'`,
			response: `{ "id": 99, "body": "Cliente VIP, tratar con prioridad", "isPrivate": true }`
		},
		{
			method: "GET",
			path: "/api/queues",
			description: "Listar departamentos disponibles de la empresa",
			body: [],
			curl: `curl -X GET ${baseUrl}/api/queues \\
  -H "x-api-token: ${tok}"`,
			response: `[{ "id": 1, "name": "Ventas" }, { "id": 2, "name": "Soporte" }]`
		},
	];

	const METHOD_COLORS = { GET: "#10b981", POST: "#3b82f6", DELETE: "#ef4444", PUT: "#f59e0b" };

	return (
		<div className={classes.devSection}>
			{ENDPOINTS.map((ep, i) => (
				<Accordion key={i} elevation={1}>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Chip
							label={ep.method}
							size="small"
							className={classes.endpointChip}
							style={{ backgroundColor: METHOD_COLORS[ep.method], color: "#fff" }}
						/>
						<span style={{ fontFamily: "monospace", marginRight: 12 }}>{ep.path}</span>
						<span style={{ color: "#888", fontSize: 13 }}>{ep.description}</span>
					</AccordionSummary>
					<AccordionDetails style={{ flexDirection: "column", gap: 8 }}>
						{ep.body.length > 0 && (
							<>
								<Typography variant="caption" style={{ fontWeight: 600 }}>Parámetros del body:</Typography>
								<table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, marginBottom: 6 }}>
									<thead>
										<tr style={{ background: "#f3f4f6" }}>
											<th style={{ textAlign: "left", padding: "4px 8px" }}>Campo</th>
											<th style={{ textAlign: "left", padding: "4px 8px" }}>Tipo</th>
											<th style={{ textAlign: "left", padding: "4px 8px" }}>Requerido</th>
											<th style={{ textAlign: "left", padding: "4px 8px" }}>Descripción</th>
										</tr>
									</thead>
									<tbody>
										{ep.body.map((b) => (
											<tr key={b.field} style={{ borderTop: "1px solid #e5e7eb" }}>
												<td style={{ padding: "4px 8px", fontFamily: "monospace", color: "#1d4ed8" }}>{b.field}</td>
												<td style={{ padding: "4px 8px", fontFamily: "monospace", color: "#6b7280" }}>{b.type}</td>
												<td style={{ padding: "4px 8px" }}>{b.required ? "✅ Sí" : "No"}</td>
												<td style={{ padding: "4px 8px" }}>{b.desc}</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
						<Typography variant="caption" style={{ fontWeight: 600 }}>Ejemplo cURL:</Typography>
						<div className={classes.codeBlock}>
							{ep.curl}
							<Tooltip title={copied === ep.path ? i18n.t("settingsExtra.copiado") : i18n.t("settingsExtra.copiar")}>
								<FileCopyIcon
									onClick={() => copy(ep.curl, ep.path)}
									style={{ position: "absolute", top: 8, right: 8, fontSize: 16, cursor: "pointer", opacity: 0.6 }}
								/>
							</Tooltip>
						</div>
						{ep.response && (
							<>
								<Typography variant="caption" style={{ fontWeight: 600 }}>Respuesta esperada:</Typography>
								<div className={classes.codeBlock} style={{ marginTop: 0 }}>{ep.response}</div>
							</>
						)}
					</AccordionDetails>
				</Accordion>
			))}
		</div>
	);
};

export default DevSection;
